import type { Wallet } from '@asia/shared';
import { haptic } from '../../hooks/useTelegram';
import { copyText } from '../../lib/clipboard';
import { CoinIcon } from '../CoinIcon';
import { FigIcon } from '../FigIcon';

const short = (a: string) => `${a.slice(0, 4)}····${a.slice(-4)}`;

/** One wallet row: TRX glyph + name (+ copy) + short address + TRON network.
 *  Shared by the Profile screen and the dedicated Wallets list screen. */
export function WalletAddressRow({ wallet, onClick }: { wallet: Wallet; onClick: () => void }) {
  return (
    <button
      onClick={() => {
        haptic();
        onClick();
      }}
      className="flex h-9 w-full items-center justify-between active:opacity-70"
    >
      <span className="flex min-w-0 items-center gap-[6px]">
        <CoinIcon symbol="TRX" size={40} />
        <span className="flex min-w-0 flex-col items-start gap-[5px]">
          <span className="flex items-center gap-[2px]">
            <span className="truncate text-[15px] font-medium text-ink">{wallet.name}</span>
            <span
              role="button"
              onClick={(e) => {
                e.stopPropagation();
                void copyText(wallet.address);
              }}
            >
              <FigIcon name="copy" size={16} className="text-muted" />
            </span>
          </span>
          <span className="flex items-center gap-[5px] text-[13px] text-muted">
            {short(wallet.address)}
            <span className="inline-block size-[2px] rounded-full bg-muted" />
            TRON
          </span>
        </span>
      </span>
      <FigIcon name="arrowRight" size={16} className="text-subtle" />
    </button>
  );
}
